<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="gf-search-filter-verification">
    <b>{{ $t('filter.verification.title') }}</b>
    <label class="gf-search-filter-verification__switch gf-custom-switch">
      <input
        v-model="isVerifiedModel"
        type="checkbox"
        @input="onVerificationModelChange"
      />
      <div>
        <span class="verification-text">
          {{ verifiedText }}
        </span>
      </div>
    </label>
  </section>
</template>

<script>
import SearchMessages from '@shared/modules/search/search.messages';

export default {
  name: 'GfSearchFilterVerification',
  props: {
    verifiedText: {
      type: String,
      default() {
        return this.$t('filter.verification.text');
      }
    }
  },
  data() {
    return {
      isVerifiedModel: false
    };
  },
  mounted() {
    if (this.$route.query.verifiedOnly?.length > 0) {
      this.isVerifiedModel = this.$route.query.verifiedOnly === 'true';
    }
  },
  methods: {
    onVerificationModelChange() {
      this.$router.push({
        query: {
          ...this.$route.query,
          verifiedOnly: !this.isVerifiedModel ? true : undefined,
          page: 0
        }
      });
    }
  },
  i18n: {
    messages: SearchMessages
  }
};
</script>

<style lang="scss">
$this: '.gf-search-filter-verification';

#{$this} {
  width: 100%;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--light);
  border: 1px solid var(--border-color);
  border-radius: 6px;

  #{$this}__switch {
    width: fit-content;

    & .verification-text {
      text-wrap: wrap;
    }
  }
}
</style>
